/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Eu_Ai_TitleInputs */

const en_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Native AI`)
};

const de_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI aus der EU`)
};

const fr_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA européenne`)
};

const es_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA nativa de la UE`)
};

const it_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA nativa UE`)
};

const nl_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-native AI`)
};

const pl_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI natywne dla UE`)
};

const fi_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-natiivi tekoäly`)
};

const da_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-native AI`)
};

const sv_landing_feature_eu_ai_title = /** @type {(inputs: Landing_Feature_Eu_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-native AI`)
};

/**
* | output |
* | --- |
* | "EU-Native AI" |
*
* @param {Landing_Feature_Eu_Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_eu_ai_title = /** @type {((inputs?: Landing_Feature_Eu_Ai_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Eu_Ai_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_eu_ai_title(inputs)
	if (locale === "fr") return fr_landing_feature_eu_ai_title(inputs)
	if (locale === "es") return es_landing_feature_eu_ai_title(inputs)
	if (locale === "it") return it_landing_feature_eu_ai_title(inputs)
	if (locale === "nl") return nl_landing_feature_eu_ai_title(inputs)
	if (locale === "pl") return pl_landing_feature_eu_ai_title(inputs)
	if (locale === "fi") return fi_landing_feature_eu_ai_title(inputs)
	if (locale === "da") return da_landing_feature_eu_ai_title(inputs)
	if (locale === "sv") return sv_landing_feature_eu_ai_title(inputs)
	return en_landing_feature_eu_ai_title(inputs)
});